import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { PlanningJob } from '../../models/planning-job';
import { WebdokuService } from '../../../web-doku/webdoku.service';
import { UntypedFormControl } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { SelectionArguments } from '../../models/selection-arguments';
import { ControlBase } from '../control-base';
import { TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'ldw-planning-job-select',
  templateUrl: './planning-job-select.component.html',
  styleUrls: ['./planning-job-select.component.css'],
  standalone: false
})
export class PlanningJobSelectComponent extends ControlBase implements OnInit {
  private webDokuService = inject(WebdokuService);
  private translate = inject(TranslateService);

  @Output() jobChanged: EventEmitter<SelectionArguments> = new EventEmitter();
  jobs: { name: string, value: string }[] = [];

  constructor() {
    super();
    const webDokuService = this.webDokuService;
    const translate = this.translate;

    // prevent empty mat-select when reloading the page
    this.translate.stream('PLANNINGJOB.NOJOB').pipe(takeUntilDestroyed()).subscribe((value) =>
      this.jobs = [{ name: value, value: '' }, ...this.webDokuService.currentPlanningJobs.map(job => ({ name: job.name, value: job.name }))]);
  }

  ngOnInit(): void {
    if (this.form != undefined) {
      this.internalControl = new UntypedFormControl(this.initialValue);
      this.form.addControl(this.controlName, this.internalControl);
    }

  }

  changed(event: MatSelectChange) {
    if (event.value == this.initialValue) {
      return;
    }
    const args = new SelectionArguments();
    args.id = event.value;
    this.jobChanged.emit(args);
    this.initialValue = event.value;
  }

}
